import type { TableProps } from '@aibees/shared/components';
import { PaginationResponse } from '@aibees/shared/definition';
import { createPaginationResponse } from '@aibees/shared/http';
import { SearchItem } from '@aibees/shared/store/search-items-store/types';
import { find } from 'lodash-es';
import type { AdvanceTableConfig, BrowseData } from '../../types';

export function toBrowseApiData(
  data: BrowseData<any>,
  { page, rowsPerPage }: TableProps
) {
  const from = page * rowsPerPage;
  return {
    data: createPaginationResponse({
      content: data.data?.slice(from, from + rowsPerPage),
      number: page,
      size: rowsPerPage,
      totalElements: data.data?.length || 0,
    }),
    isLoading: data.isLoading,
    isFetching: data.isLoading,
    refetch: null,
  };
}

export function calculateTableSort(
  table: TableProps,
  appendedSort: AdvanceTableConfig['prependSortingFields']
) {
  const fields = { ...appendedSort };
  if (table.orderBy) fields[table.orderBy] = table.order;
  const order = Object.keys(fields).map((x) => `${x}:${fields[x]}`);
  return order.join(',') || undefined;
}

export function getUpdatedSearchContent(
  currentData: PaginationResponse['content'],
  updatedData: SearchItem[]
) {
  return currentData.map((item) => {
    const found = find(updatedData, { id: item.id });
    return found ? ({ ...item, ...found } as SearchItem) : (item as SearchItem);
  });
}
